export enum EventEnum {
    USER = 'user',
    BOT = 'bot',
    ACTION = 'action',
}

interface IMetadata {
    model_id: string
}

interface IBotMetadata extends IMetadata {
    utter_action: string
}

interface IData {
    attachment: null
    buttons: {
        payload: string
        title: string
    }[]
    custom: {
        quest: {
            messages: string[]
            progress: number
            success: boolean
        }
    }
    elements: null
    image: null
    quick_replies: null
}

interface IParseData {
    entities: {
        confidence_entity: number
        end: number
        entity: string
        extractor: string
        start: number
        value: string
    }[]
    intent: {
        confidence: number
        name: string
    }
    intent_ranking: {
        confidence: number
        name: string
    }[]
    message_id: string
    metadata: object
    text: string
}

interface IMessage {
    sender_id: string
    timestamp: number
}

export interface IUserMessage extends IMessage {
    event: EventEnum.USER
    text: string
    metadata: IMetadata
    input_channel: string
    message_id: string
    parse_data: IParseData
}

export interface IBotMessage extends IMessage {
    event: EventEnum.BOT
    metadata: IBotMetadata
    data: IData
    text: string
}

export interface IActionMessage extends IMessage {
    event: EventEnum.ACTION
    confidence: number | null
    action_text: string | null
    hide_rule_turn: boolean
    metadata: IMetadata
    name: string
    policy: string
}

export type MessageType = IUserMessage | IBotMessage | IActionMessage
